import { render, staticRenderFns } from "./AddTextStampInput.vue?vue&type=template&id=267190cc&scoped=true&"
import script from "./AddTextStampInput.vue?vue&type=script&lang=js&"
export * from "./AddTextStampInput.vue?vue&type=script&lang=js&"
import style0 from "./AddTextStampInput.vue?vue&type=style&index=0&id=267190cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267190cc",
  null
  
)

export default component.exports